import intl from 'intl';

import { addLocaleData } from 'react-intl';
import moment from 'moment';
import moment_tz from 'moment-timezone';

// Intl config store
const intlConfig = {};

const settings = (key, obj) => {
  if (!intlConfig.hasOwnProperty(key)) {
    intlConfig[key] = obj;
  }
  return intlConfig[key];
};

const defaultConfig = {
  formats: {
    number: {
      price: {
        style: 'currency',
        currency: 'EUR',
      },
    },
  },
};

// Gets config by locale
const getLocaleConfig = (locale) => {
  const config = settings('intl');
  const lang = locale || config.default.locale;
  const languageCode = config[lang.slice(0, 2)] || config.default;
  return languageCode[lang] || languageCode.default || languageCode;
};

// Configure Intl (entry point)
const configureIntl = (config, locales, options = { defaultLocale: '' }) => {
  if (typeof window.Intl === 'undefined') window.Intl = intl;

  settings('intl', config);
  addLocaleData(locales);

  const { locale, messages, formats } = getLocaleConfig(
    options.userLocale || options.defaultLocale || navigator.language || navigator.userLanguage
  );

  moment.locale(locale);
  moment_tz.locale(locale);

  return {
    defaultLocale: locale,
    locale,
    messages,
    formats: formats || settings('intl').default.formats || defaultConfig,
  };
};

export { configureIntl };
